export default [
  'FLOWVIZ',
  'FORECAST',
  'TEMPERATURE_FORECAST',
  'PRESSURE_FORECAST',
  'HUMIDITY_FORECAST',
  'MARINE_FORECAST',
  'SURFACE_CURRENTS',
  'WIND',
  'WIND_GUST',
  'RADAR',
  'SATELLITE',
  'RADAR_WIND',
  'RADAR_GUST',
  'SATELLITE_WIND',
  'SST',
  'ONSITE_REPORTS',
  'LIGHTNING',
  'PRECIP_ACCUMULATION',
  'WATCHES_WARNINGS',
  'WATER_LEVEL',
  'NAUTICAL_CHARTS_WIND',
]